// ponytail: brand deny-list — single source so marketing add/remove is a one-line change
export const BUFFALO_HIDDEN_VEHICLE_TYPES = Object.freeze([
    'scooter',
    'dirt bike',
    'golf cart',
    'rv',
    'mower',
    'tractor',
    'marine',
    'marine power boat',
    'automobile',
]);
